/** Pure board maths, kept out of the component so it can be checked on its own. */
import { POSITION_ORDER, clampPosition, sortStances } from '../components/format';
import type { StanceView } from '../../../types/issues';

export type ColumnSort = 'influence' | 'recent' | 'name';

export interface BoardColumn {
  position: number;
  stances: StanceView[];
  /** Summed issue influence in this column — the weight of the camp */
  influence: number;
}

/**
 * Five columns, always all five, sorted inside by whatever the analyst chose.
 * An empty column is information: nobody is championing this.
 */
export function buildColumns(stances: StanceView[], sort: ColumnSort = 'influence'): BoardColumn[] {
  const buckets = new Map<number, StanceView[]>(POSITION_ORDER.map((position) => [position, []]));
  stances.forEach((stance) => {
    const bucket = buckets.get(clampPosition(stance.position));
    if (bucket) bucket.push(stance);
  });
  return POSITION_ORDER.map((position) => {
    const list = buckets.get(position) || [];
    return {
      position,
      stances: sortStances(list, sort),
      influence: list.reduce((total, stance) => total + (stance.issueInfluence || 0), 0),
    };
  });
}
